import { Chip } from '@mui/material';
import { alpha } from '@mui/material/styles';

import { Request } from '../../models/request.types';

const labels: Record<string, string> = {
	[Request.status.readyForPayment]: 'Ready for Payment',
	[Request.status.readyForSchedule]: 'Ready for Schedule',
	[Request.status.readyForAssessment]: 'Ready for Assessment',
	[Request.status.readyForApproval]: 'Ready for Approval',
	[Request.status.completed]: 'Completed',
	[Request.status.cancelled]: 'Cancelled',
};

const colors: Record<string, string> = {
	[Request.status.readyForPayment]: '#FF9015',
	[Request.status.readyForSchedule]: '#20C997',
	[Request.status.readyForAssessment]: '#6CDAEB',
	[Request.status.readyForApproval]: '#0096F1',
	[Request.status.completed]: '#89D240',
	[Request.status.cancelled]: '#F73737',
};

interface StatusProps {
	status: string;
	clickable?: boolean;
	onClick?: (event: React.MouseEvent<HTMLDivElement>) => void;
	correlationId?: string | number;
}

export const Status: React.FC<StatusProps> = ({ status, clickable = false, onClick, correlationId }) => {
	if (!labels[status]) {
		return <span />;
	}

	const onHover = clickable
		? {
				':hover': {
					cursor: 'pointer',
					backgroundColor: alpha(colors[status], 0.5),
				},
			}
		: {};

	return (
		<Chip
			label={labels[status]}
			onClick={onClick}
			clickable={clickable}
			sx={{
				backgroundColor: colors[status],
				color: '#000',
				fontWeight: 'bold',
				width: { xs: 120, sm: 130, md: 150 },
				fontSize: { xs: '0.7rem', sm: '0.75rem', md: '0.8rem' },
				...onHover,
			}}
			data-correlation-id={correlationId}
		/>
	);
};
